/**
 * One layout table for the collectible card, expressed in card-width units
 * (`cqi` in the DOM, `unit * CARD_SCALE` pixels on the export canvas).
 *
 * The card is 4:5, so the unit box is 100 wide by 125 tall and the 1080x1350
 * export is exactly 10.8 pixels per unit. Both renderers read these numbers,
 * which is what keeps the screen card and the downloaded PNG the same object.
 */
export const CARD_WIDTH_UNITS = 100;
export const CARD_HEIGHT_UNITS = 125;
export const CARD_EXPORT_WIDTH = 1080;
export const CARD_EXPORT_HEIGHT = 1350;
export const CARD_SCALE = CARD_EXPORT_WIDTH / CARD_WIDTH_UNITS;

export const CARD = {
  padX: 6.8,
  rail: { y: 7.4, size: 2.05 },
  identity: {
    labelY: 15.8,
    labelSize: 1.65,
    titleY: 21.3,
    titleSize: 4.9,
    metaY: 25.7,
    metaSize: 2.15,
  },
  level: {
    y: 49.2,
    labelSize: 8.8,
    numberSize: 18.5,
    englishY: 57.2,
    englishSize: 2.2,
  },
  desc: { y: 66.0, size: 2.7, leading: 3.8, lines: 3 },
  score: { y: 91.4, size: 11.8, unitSize: 2.8 },
  meta: {
    labelY: 108.0,
    valueY: 112.0,
    labelSize: 1.55,
    valueSize: 2.25,
    refX: 60.5,
  },
  ruleFoot: 118.2,
  /** Scan target, bottom-right. Sized so the export keeps ~5px per module. */
  qr: { size: 13.8, y: 104.4, quiet: 1.0 },
} as const;

/** Right edge of the text column once the QR block is reserved. */
export const CARD_TEXT_RIGHT = CARD_WIDTH_UNITS - CARD.padX - CARD.qr.size - 2.8;

export const CARD_INK = '#f4f1ea';
export const CARD_MUTED = '#9298a6';
export const CARD_SURFACE = '#0a0b0f';

export const unit = (value: number): string => `${value}cqi`;
export const px = (value: number): number => value * CARD_SCALE;

/**
 * The table stores text baselines because the export canvas draws from
 * baselines. The DOM positions boxes from their top edge, so convert with the
 * usual ~0.8em ascent of the shipped families.
 */
export const topFor = (baseline: number, size: number): string => unit(baseline - size * 0.8);
